export default __webpack_public_path__ + "static/media/certificate-sample.b6ac5349.png";